module.exports = __webpack_public_path__ + "static/media/kid.8c2fb070.png";